/* here we defined the common methods to deal with cookies */


/* this method is used to fetch the data from the cookies */
export const getCookie = name => {
    if ( typeof window !== 'undefined' ) {
      let cookieString = document.cookie.split( ';' ).find( e => e.includes( name ) );
      let cookieArr = cookieString?.split('=');
      cookieArr?.shift();
      let cookieValue = cookieArr?.join('=').trim();
  
      return cookieValue;
    }
  };
  

  
/* this method is used to set the data in the cookies */
  export const setCookie = ( cName, cValue, expiry = 86400 ) => {
    if (typeof window !== 'undefined') {
        const d = new Date();
        d.setTime(d.getTime() + (expiry*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
    }
  };
  

  
/* this method is used to delete the data from the cookies */
  export const deleteCookie = (name) => {
    if (typeof window !== 'undefined') {
      const { hostname } = window.location;
      // remove any subdomains, e.g. www.example.com -> example.com
      const domainArray = `.${hostname.match(/^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/)}`.split(',');
      let domain = Array.isArray(domainArray) ? `.${domainArray[1]}` : '';
      domain = hostname === 'localhost' ? 'localhost' : domain;
  
      document.cookie = `${String(name)}=; path=/; domain=${domain};expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      document.cookie = `${String(name)}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  };
  

